export default __webpack_public_path__ + "static/media/ba.6b95169b.svg";